var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('profitability',{attrs:{"dashboard-view":"","title":_vm.$t('Dashboard.Banking.AssetAndLiabilityManagement.Title'),"title-icon":'grey',"title-icon-size":5}})}
var staticRenderFns = []

export { render, staticRenderFns }